import XIcon from "@uui/XClose";

import { IconButton, Typography } from "@mui/material";

import {
  getPaymentMethodDescription,
  isCard,
} from "@app/analytics/account/Billing/utils";
import type { PaymentMethod } from "@app/common/types";

import Chip from "@rui/Chip";
import { Row } from "@rui/Stack";

interface CardItemProps {
  paymentMethod: PaymentMethod;
  onRemove?: () => void;
}

const PaymentMethodDetails = ({ paymentMethod, onRemove }: CardItemProps) => {
  return (
    <Row variant="apart" sx={{ color: "shades.neutral.800", width: "100%" }}>
      <Row spacing={1} variant="left">
        <Typography>{getPaymentMethodDescription(paymentMethod)}</Typography>
        <Chip color="shades.neutral.500" bgcolor="shades.neutral.100">
          Default
        </Chip>
      </Row>
      {isCard(paymentMethod) && (
        <Typography>
          Expires {paymentMethod.card.expMonth}/{paymentMethod.card.expYear}
        </Typography>
      )}
      {onRemove && (
        <IconButton onClick={onRemove}>
          <XIcon sx={{ color: "shades.neutral.500", fontSize: "16px" }} />
        </IconButton>
      )}
    </Row>
  );
};

export default PaymentMethodDetails;
